import(/* webpackMode: "eager" */ "/asetters/app/global-error.tsx")